<template>
  <div class="documents">
    <div class="row">
      <h6>Private/Public limited companies</h6>
      <h6>Partnership firms</h6>
      <h6>Proprietorship firms</h6>
    </div>

    <div v-for="(data, index) in docsRequired" :key="index" class="row">
      <p>{{data.col1}}</p>
      <p>{{data.col2}}</p>
      <p>{{data.col3}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Documents',
  data () {
    return {
      docsRequired: []
    }
  },
  created () {
    this.docsRequired = [
      {
        col1: 'Certificate of incorporation',
        col2: 'Registration certificate',
        col3: 'Registration certificate'
      },
      {
        col1: 'Company PAN card',
        col2: 'Company PAN card'
      },
      {
        col1: 'Company cancelled cheque',
        col2: 'Company cancelled cheque',
        col3: 'Company cancelled cheque'
      },
      {
        col1: 'Company GST (optional)',
        col2: 'Company GST (optional)',
        col3: 'Company GST'
      },
      {
        col1: 'AoA & MoA',
        col2: 'Partnership deed'
      },
      {
        col1: 'Authorized signatory PAN card',
        col2: 'Partner PAN card',
        col3: 'Proprietor PAN card'
      },
      {
        col1: 'Authorized signatory Aadhaar card',
        col2: 'Partner Aadhaar card',
        col3: 'Proprietor Aadhaar card'
      },
      {
        col1: 'Business Details',
        col2: 'Business Details',
        col3: 'Business Details'
      },
      {
        col1: 'Website',
        col2: 'Website',
        col3: 'Website'
      }
    ]
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .documents {
    border: 2px solid $grey-outline;

    .row {
      @include custom-flex(flex-start, null);
      border-bottom: 2px solid $grey-outline;

      &:last-child {
        border-bottom: none;
      }

      &:nth-child(even) {
        background: rgb(248, 247, 247);
      }

      .content {
        flex: 1;
        text-align: left;
        padding: 5px;
        border-right: 2px solid $grey-outline;
        max-width: 33%;

        &:last-child {
          border-right: none;
        }
      }

      h6 {
        @extend .content;
        @include normal-text($secondary, 13px, 600);
      }
      p {
        @extend .content;
        @include normal-text($secondary, 13px);
      }
    }
  }
</style>
